import { QuestionBase } from './base.question.class'

export class TextQuestion extends QuestionBase<string> {
  controlType = 'textarea'
}
